import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import KeyFeatureModal from './KeyFeatureModal';
import { toast } from "react-toastify"; // ✅ Only toast is needed


const KeyFeatures = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    const [features, setFeatures] = useState([]);  // remove dummy data
    const [filteredFeatures, setFilteredFeatures] = useState(features);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
      const [editingIndex, setEditingIndex] = useState(null);
    const [modalValue, setModalValue] = useState('');
    

            const BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const filtered = features.filter((feature) =>
            feature.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredFeatures(filtered);
        setCurrentPage(1);
    }, [searchQuery, features]);

    const totalPages = Math.ceil(filteredFeatures.length / itemsPerPage);
    const currentData = filteredFeatures.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

useEffect(() => {
    const fetchFeatures = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/key-features`);
            if (!res.ok) throw new Error("Failed to fetch features");
            const data = await res.json();
            setFeatures(data);
        } catch (err) {
            console.error("Error loading features:", err);
        }
    };

    fetchFeatures();
}, []);


    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

   const handleDelete = async (indexInPage) => {
    const realIndex = (currentPage - 1) * itemsPerPage + indexInPage;
    const featureToDelete = features[realIndex];

    if (!window.confirm(`Are you sure you want to delete "${featureToDelete.name}"?`)) return;

    try {
        const res = await fetch(`${BASE_URL}/api/key-features/${featureToDelete.id}`, {
            method: 'DELETE',
        });

        if (!res.ok) throw new Error('Failed to delete feature');

        const updated = features.filter((_, index) => index !== realIndex);
        setFeatures(updated);
                toast.success(`"${featureToDelete.name}" deleted successfully!`); // ✅ Success Toast

    } catch (err) {
        console.error('Error deleting feature:', err);
        toast.error('Failed to delete feature');
    }
};


     const handleAddClick = () => {
        setEditingIndex(null);
        setModalValue('');
        setIsModalOpen(true);
    };

    const handleEditClick = (index) => {
        const realIndex = (currentPage - 1) * itemsPerPage + index;
        setEditingIndex(realIndex);
        setModalValue(features[realIndex].name);
        setIsModalOpen(true);
    };
const handleModalSubmit = async (value) => {
    if (!value.trim()) return;

    try {
        if (editingIndex !== null) {
            // Update (PUT)
            const featureToUpdate = features[editingIndex];

            const response = await fetch(`${BASE_URL}/api/key-features/${featureToUpdate.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!response.ok) {
                throw new Error("Failed to update feature");
            }

            const updatedFeature = await response.json();

            const updated = [...features];
            updated[editingIndex] = updatedFeature;
            setFeatures(updated);
                        toast.success(`"${value.trim()}" updated successfully!`); // ✅ Success Toast

        } else {
            // Create (POST)
            const response = await fetch(`${BASE_URL}/api/key-features`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!response.ok) {
                throw new Error("Failed to create feature");
            }

            const newFeature = await response.json();
            setFeatures([...features, newFeature]);
                        toast.success(`"${value.trim()}" added successfully!`); // ✅ Success Toast

        }

        setIsModalOpen(false);
        setModalValue('');
        setEditingIndex(null);
    } catch (err) {
        console.error("Error submitting feature:", err);
        toast.error("Failed to submit feature");
    }
};



    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Key Features</h1>
                    <button className="oms-add-btn" onClick={handleAddClick}>
                        Add Feature
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search feature..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ minWidth: '200px' }}>Feature Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((feature, index) => (
                                    <tr key={index}>
                                        <td>{feature.name}</td>
                                        <td>
                                            <button className="edit-button" onClick={() => handleEditClick(index)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center' }}>
                                        No features found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

            <KeyFeatureModal  isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                initialValue={modalValue}
                onSubmit={handleModalSubmit}/>
        </>
    );
};

export default KeyFeatures;
